import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_EVENT_TRIGGERS_EVENT_PROPERTIES } from 'flow-doctor-lib/queries/FrameworkBuilderQueries';
import useObjectTypeProperties from 'flow-doctor-lib/hooks/useObjectTypeProperties';
const buildFrameworkBuilderPropertyMap = (objectTypeId, propertyInput) => {
  return Object.entries(propertyInput).reduce((acc, [propertyName, propertyMetadata]) => {
    return Object.assign({}, acc, {
      [propertyName]: {
        objectTypeId,
        property: {
          name: propertyName,
          label: propertyMetadata.label,
          type: propertyMetadata.type,
          hidden: propertyMetadata.hidden === 'true',
          externalOptions: !!propertyMetadata.referenceType,
          referenceType: propertyMetadata.referenceType,
          options: []
        }
      }
    });
  }, {});
};
const useHubSpotDefinedEventProperties = ({
  portalId,
  objectTypeId
}, {
  skip
} = {}) => {
  // Fetch what we can from the framework builder, then fetch the regular property definition for any outliers
  const {
    data: eventPropertiesData,
    loading: eventPropertiesLoading,
    error: eventPropertiesError
  } = useQuery(GET_EVENT_TRIGGERS_EVENT_PROPERTIES, {
    variables: {
      portalId,
      eventFQNOrObjectTypeId: objectTypeId
    },
    skip
  });
  const {
    data: objectTypeData,
    loading: objectTypeLoading,
    error: objectTypeError
  } = useObjectTypeProperties({
    portalId,
    objectTypeId
  }, {
    skip
  });
  const dataToReturn = useMemo(() => {
    const eventTriggersPropertyMap = eventPropertiesData ? buildFrameworkBuilderPropertyMap(objectTypeId, eventPropertiesData.flowDoctor_eventTriggersEventProperties) : {};
    return Object.assign({}, objectTypeData, eventTriggersPropertyMap);
  }, [eventPropertiesData, objectTypeData, objectTypeId]);
  return {
    data: dataToReturn,
    loading: eventPropertiesLoading || objectTypeLoading,
    error: eventPropertiesError || objectTypeError
  };
};
export default useHubSpotDefinedEventProperties;